import { useI18n } from "@/i18n/I18nProvider";

type Props = {
  brandSlug: string;
  source?: string;
  placement?: string;
  variant?: "primary" | "accent";
  size?: "md" | "lg";
  label?: string;
};

export function AffiliateCTA({
  brandSlug,
  source,
  placement,
  variant = "accent",
  size = "md",
  label,
}: Props) {
  const { t, lang } = useI18n();
  const params = new URLSearchParams();
  if (source) params.set("source", source);
  if (placement) params.set("placement", placement);
  params.set("lang", lang);
  const href = `/go/${brandSlug}?${params.toString()}`;
  const cls =
    variant === "accent"
      ? "btn-accent"
      : "btn-primary";
  const sizeCls = size === "lg" ? "text-base px-6 py-3" : "";
  return (
    <a
      href={href}
      rel="sponsored noopener"
      target="_blank"
      className={`${cls} ${sizeCls}`}
      data-brand={brandSlug}
      data-placement={placement}
    >
      {label ?? t("cta.visitCasino")}
    </a>
  );
}
